import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'workers',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/public/public.module').then( m => m.PublicModule)
  },
  {
    path: 'production-orders',
    loadChildren: () => import('./modules/production-orders/production-orders.module').then( m => m.ProductionOrdersModule),
    canLoad: [AuthGuard]
  },{
    path: 'production-order',
    loadChildren: () => import('./modules/production-order/production-order.module').then( m => m.ProductionOrderModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'phases',
    loadChildren: () => import('./modules/phases/phases.module').then( m => m.PhasesModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'worker-activities',
    loadChildren: () => import('./modules/worker-activities/worker-activities.module').then( m => m.WorkerActivitiesModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'workers',
    loadChildren: () => import('./modules/workers/workers.module').then( m => m.WorkersModule),
    canLoad: [AuthGuard]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
